var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-card', {
    staticClass: "pa-4"
  }, [_c('v-toolbar', {
    attrs: {
      "flat": "",
      "color": "primary",
      "dark": ""
    }
  }, [_c('v-icon', {
    staticClass: "mr-2"
  }, [_vm._v("mdi-eye")]), _vm._v(" Acompanhar Turma - Visualizar "), _c('v-spacer')], 1), _vm.turma ? _c('div', [_c('div', {
    staticClass: "my-3 pa-4",
    staticStyle: {
      "border": "1px solid #ccc",
      "border-radius": "8px"
    }
  }, [_vm._l(_vm.turma.professores, function (professor) {
    return _c('DadosProfissionaisComponent', {
      key: professor.id,
      attrs: {
        "profissional": professor
      }
    });
  }), _c('v-divider', {
    staticClass: "my-4"
  }), _vm.turma.articuladoresRegionais ? _c('ProfissionaisPorFuncaoComponent', {
    attrs: {
      "funcao": 'Articulador Regional',
      "profissionais": _vm.turma.articuladoresRegionais
    }
  }) : _vm._e(), _vm.turma.articuladoresMunicipais ? _c('ProfissionaisPorFuncaoComponent', {
    attrs: {
      "funcao": 'Articulador Municipal',
      "profissionais": _vm.turma.articuladoresMunicipais
    }
  }) : _vm._e()], 2), _c('DadosDaTurmaComponent', {
    attrs: {
      "turma": _vm.turma
    }
  }), _c('v-tabs', {
    staticClass: "mt-4",
    model: {
      value: _vm.abaSelecionada,
      callback: function ($$v) {
        _vm.abaSelecionada = $$v;
      },
      expression: "abaSelecionada"
    }
  }, _vm._l(_vm.bimestres, function (bimestre) {
    return _c('v-tab', {
      key: bimestre
    }, [_vm._v(" " + _vm._s(bimestre) + "º Bimestre ")]);
  }), 1), _c('v-tabs-items', {
    model: {
      value: _vm.abaSelecionada,
      callback: function ($$v) {
        _vm.abaSelecionada = $$v;
      },
      expression: "abaSelecionada"
    }
  }, _vm._l(_vm.turma.bimestres, function (bimestre) {
    return _c('v-tab-item', {
      key: bimestre.numero
    }, [_c('v-expansion-panels', {
      attrs: {
        "multiple": ""
      }
    }, [_vm._l(bimestre.perfis, function (perfisTurma, nomePerfil) {
      return _c('v-expansion-panel', {
        key: nomePerfil,
        staticClass: "mt-2"
      }, [_c('v-expansion-panel-header', {
        staticClass: "font-weight-bold text-subtitle-1"
      }, [_vm._v(" Perfil da Turma em " + _vm._s(nomePerfil) + " ")]), _c('v-expansion-panel-content', [_c('v-data-table', {
        staticClass: "elevation-1",
        attrs: {
          "headers": _vm.lists.headerPerfis,
          "items": perfisTurma,
          "hide-default-footer": ""
        }
      })], 1)], 1);
    }), _vm._l(bimestre.habilidades, function (habilidadesTurma, nomeHabilidade) {
      return _c('v-expansion-panel', {
        key: nomeHabilidade,
        staticClass: "mt-2"
      }, [_c('v-expansion-panel-header', {
        staticClass: "font-weight-bold text-subtitle-1"
      }, [_vm._v(" " + _vm._s(nomeHabilidade) + " ")]), _c('v-expansion-panel-content', {
        staticClass: "px-4"
      }, [_c('v-data-table', {
        staticClass: "elevation-1",
        attrs: {
          "headers": _vm.lists.headerHabilidades,
          "items": habilidadesTurma,
          "hide-default-footer": ""
        }
      })], 1)], 1);
    })], 2)], 1);
  }), 1)], 1) : _vm._e(), _vm.semPermissao ? _c('div', {
    staticClass: "mt-4 pa-4"
  }, [_c('v-alert', {
    attrs: {
      "type": "error"
    }
  }, [_vm._v(" Você não tem permissão para visualizar o acompanhamento desta turma. ")])], 1) : _vm._e(), _c('v-card-actions', [_c('v-btn', {
    staticClass: "mt-4",
    attrs: {
      "outlined": "",
      "color": "primary"
    },
    on: {
      "click": _vm.voltar
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("mdi-arrow-left")]), _vm._v(" Voltar ")], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }